import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { API } from '@/constants/bluemonk';

export const AdminDeliverableModal = ({ open, onOpenChange, item, headers, onSuccess }) => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    brand: 'all',
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (item) {
      setFormData({
        title: item.title || '',
        description: item.description || '',
        brand: item.brand || 'all',
      });
    } else {
      setFormData({
        title: '',
        description: '',
        brand: 'all',
      });
    }
  }, [item, open]);

  const handleSubmit = async () => {
    if (!formData.title) {
      toast.error('Please enter a title');
      return;
    }

    setLoading(true);
    try {
      if (item) {
        await axios.put(`${API}/deliverables/${item.id}`, formData, { headers });
        toast.success('Deliverable updated');
      } else {
        await axios.post(`${API}/deliverables`, formData, { headers });
        toast.success('Deliverable created');
      }
      onSuccess();
    } catch (error) {
      toast.error('Failed to save');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg bg-white">
        <DialogHeader>
          <DialogTitle>{item ? 'Edit' : 'Add'} Deliverable</DialogTitle>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          <div>
            <Label>Title *</Label>
            <Input
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              className="mt-1"
            />
          </div>

          <div>
            <Label>Description</Label>
            <Textarea
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              className="mt-1"
              rows={3}
            />
          </div>

          <div>
            <Label>Brand</Label>
            <Select value={formData.brand} onValueChange={(v) => setFormData({ ...formData, brand: v })}>
              <SelectTrigger className="mt-1">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Brands</SelectItem>
                <SelectItem value="renew-circuits">Renew Circuits</SelectItem>
                <SelectItem value="bluemonk-group">BlueMonk Group</SelectItem>
                <SelectItem value="deshwal">Deshwal</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="flex justify-end gap-3 pt-4 border-t">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button onClick={handleSubmit} disabled={loading} className="bg-primary hover:bg-primary/90">
              {loading ? 'Saving...' : item ? 'Update' : 'Create'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
